import { EWebsiteThemeColorNames } from '@libs/themes/src/variants/website/enums/color.enum';

export const WEBSITE_THEME_COLORS_VARIABLES = {
    [EWebsiteThemeColorNames.light]: '--light-color',
    [EWebsiteThemeColorNames.dark]: '--dark-color',
    [EWebsiteThemeColorNames.primary]: '--primary-color',
    [EWebsiteThemeColorNames.secondary]: '--secondary-color',
    [EWebsiteThemeColorNames.accent]: '--accent-color',
};
